import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { postTiktokIntegration } from 'services/integrationService';

const TiktokCallback = () => {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const state = queryParams.get('state');
    const scopes = queryParams.get('scopes');

    if (code) {
      postTiktokIntegration({
        code: code,
        state: state,
        redirect_uri: `${window.location.origin}/callbacks/tiktok`,
      })
        .then(() => {
          if (window.opener) {
            window.opener.postMessage({ type: 'TIKTOK_SUCCESS', payload: {} }, window.location.origin);
          }
          window.close();
        })
        .catch((error) => {
          console.error('Error completing TikTok auth:', error);
          if (window.opener) {
            const errorData = error?.response?.data || {};
            window.opener.postMessage(
              {
                type: 'TIKTOK_ERROR',
                payload: {
                  message: errorData.error || errorData.message || 'Failed to connect TikTok account',
                },
              },
              window.location.origin,
            );
          }
          window.close();
        });
    } else {
      // No code — user denied or error
      const error = queryParams.get('error');
      if (window.opener) {
        window.opener.postMessage(
          {
            type: 'TIKTOK_ERROR',
            payload: { message: error || 'TikTok authorization was denied' },
          },
          window.location.origin,
        );
      }
      window.close();
    }
  }, [location]);

  return <div>Processing TikTok Login...</div>;
};

export default TiktokCallback;
